// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"a650d806","453":"79d09967","872":"70eb6c58"}[chunkId] + ".chunk.js";
};